/*import React from 'react';*/
import {render} from 'react-dom';
import routes from './config/routes';
import './index.css';

render(
  routes,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/